import { render, staticRenderFns } from "./XTable.vue?vue&type=template&id=407e00a8&scoped=true"
import script from "./XTable.vue?vue&type=script&lang=js"
export * from "./XTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407e00a8",
  null
  
)

export default component.exports